import List from "@/components/list";
import store from "@/store";
import { tableBaseProps } from "@/utils/common.js";
import { classTransferringInfoNew } from "@/api/studyService";
import { Message } from "element-ui";

const Table = (args) => {
  const {
    selectChange,
    edit,
    del,
    publish,
    unpublish,
    letterManage,
    studentManage,
    note,
    postpone,
    smsNotice,
    toDetail,
  } = args.listeners;

  const nowUuid = store.getters.uuid;
  console.log('nowUuid,',nowUuid)

  const flatPermissions = store.getters.flatPermissions;
  // 当增加按钮权限时，需在这维护按钮的权限列表
  const permissionList = [];

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const { publishStatus, delayStatus, classStatus } = item;
    const dealConf = [
      [
        "icon-edit",
        "编辑",
        () => {
          edit(item);
        },
        "centerSelectClass:update",
      ],
      [
        "icon-delete",
        "删除",
        () => {
          del(item);
        },
        "centerSelectClass:delete",
      ],
    ];

    if (publishStatus === 0) {
      dealConf.push([
        "icon_fabu",
        "发布",
        () => {
          publish(item);
        },
        "centerSelectClass:publish",
      ]);
    }
    dealConf.push([
      "iconfont ic_a-xuantiaohanguanli-moren2x iconfont-adapt",
      "选调函管理",
      () => {
        letterManage(item);
      },
      "offlineClass:selLetter",
    ]);

    dealConf.push([
      "icon-student",
      "学员管理",
      () => {
        studentManage(item);
      },
      "classOffline:pageStudent",
    ]);

    dealConf.push([
      "iconfont ic_a-banjibeizhu-moren2x iconfont-adapt",
      "班级备注",
      () => {
        note(item);
      },
      "centerSelectClass:updateRemarks",
    ]);

    const delayFlag = (delayStatus === 1 || classStatus < 3) && publishStatus !== 0;
    dealConf.push([
      delayFlag
        ? "iconfont icyanqishezhi iconfont-adapt"
        : "iconfont icyanqishezhi iconfont-adapt-disabled",
      "延期设置",
      () => {
        delayFlag && postpone(item);
      },
      "classOperationLog:list",
    ]);
    dealConf.push([
      publishStatus === 1 ? "ic-report-sms" : "ic-report-sms-disable",
      "短信通知",
      () => {
        if(publishStatus !== 1 ) return
        classTransferringInfoNew({uuid: item.uuid}).then(({code, data}) => {
          if(code !== 0) return
          const {auditUserIds = []} = data
          if(auditUserIds.indexOf(nowUuid) !== -1){
            smsNotice(item);
          } else {
            Message({
              message: "仅班级管理员可以发送短信通知",
              type: "warning",
            });
          }
        })
        
      },
      "",
    ]);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ClassStatusName = ({ props: { vo } }) => {
    const classStatusName = vo.row.classStatusName
      ? vo.row.classStatusName
      : "--";
    return <div domPropsInnerHTML={classStatusName}></div>;
  };

  const ClassName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          toDetail(item);
        }}
      >
        {item.className}
      </div>
    );
  };
  const EnrollTime = ({ props: { vo } }) => {
    const { trainStartTime, trainEndTime } = vo.row;
    return (
      <div class="table-row-column">
        <span>{trainStartTime}</span>
        <span>{trainEndTime}</span>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      ...tableBaseProps("班级名称", "className", "m200", false),
      render: (vo) => <ClassName vo={vo} />,
    },
    tableBaseProps("主办单位", "organizer", "m100"),
    tableBaseProps("班级类型", "trainTypeName", "120"),
    tableBaseProps("办班级别", "classLevelName", "120"),
    {
      ...tableBaseProps("报名情况", "enrollSituation", "110"),
      renderHeader: () => {
        return (
          <div class="table-row-column">
            <span>报名情况</span>
            <span>报名|计划(人)</span>
          </div>
        );
      },
    },
    {
      ...tableBaseProps("班级状态", "classStatusName", "80"),
      render: (vo) => <ClassStatusName vo={vo} />,
    },
    tableBaseProps("发布状态", "publishStatusName", "80"),
    {
      ...tableBaseProps("培训时间", "", "100"),
      render: (vo) => <EnrollTime vo={vo} />,
    },
    tableBaseProps("结业率", "graduationRate", "80"),
  ];
  // let iconNum = 0;
  // permissionList.forEach((x) => {
  //   if (flatPermissions.includes(x)) {
  //     iconNum += 1;
  //   }
  // });
  // if (iconNum > 0) {
  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    // width: String(iconNum * 30 + 10 > 130 ? 130 : iconNum * 30 + 10),
    width: 130,
    render: (vo) => <Deal vo={vo} />,
  });
  // }
  return (
    <List
      {...args}
      onSelectionChange={selectChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
